import Cookies from 'js-cookie';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';

export function initMyTeam() {
    const hasMyTeamCookie = !!Cookies.get('isMyTeam');

    if (IS_MY_TEAM && !hasMyTeamCookie) {
        Cookies.set('isMyTeam', 'true');
    }
}
